import Vue from 'vue'
import Router from 'vue-router'
import vueAuthInstance from '../services/authenticationService.js'

import DashView from '@/components/dash'
import LoginView from '@/components/login'
import NotFound from '@/components/404'

import Person from '@/components/management/person/index'
import PersonShow from '@/components/management/person/shows/index'
/*import PersonForm from '@/components/management/person/Form'*/
// import PersonShow from '@/components/management/person/shows/Index'

import CourseView from '@/components/management/course/course'
import AcademicYear from '@/components/management/course/academicYear/index'
import ActiveCourse from '@/components/management/course/activeCourse/index'

// import SectionView from '@/components/management/course/section/Section'
import Section from '@/components/management/course/section/index'
import SectionShow from '@/components/management/course/section/shows/index'

import CoursePlan from '@/components/management/course/coursePlan/index'

import Instructor from '@/components/management/instructor/index'

import Internet from '@/components/management/internet/index'
import Parking from '@/components/management/parking/index'
import Student from '@/components/management/student/index'

import Building from '@/components/settings/building/index'
import Campus from '@/components/settings/campus/index'
import PersonType from '@/components/settings/personType/index'
import ActivityType from '@/components/settings/activityType/index'
import Subject from '@/components/settings/subject/index'
import WageRate from '@/components/settings/wageRate/index'

import Reports from '@/components/reports'
import Guest from '@/components/reports/guest/index'
import Wage from '@/components/reports/wage/index'
import Workload from '@/components/reports/workload/index'
import TeachingSubjects from '@/components/reports/teachingSubjects/index'
import CoursePlanReport from '@/components/reports/coursePlan/index'
import AggregateStudent from '@/components/reports/aggregateStudent/index'
import ParkingRequest from '@/components/reports/requests/parking'
import InternetRequest from '@/components/reports/requests/internet'
import StudentRequest from '@/components/reports/requests/student'
import PersonReport from '@/components/reports/person'
import ActivityGenReport from '@/components/reports/activity/gen'
import ActivityGenStaffReport from '@/components/reports/activity/genStaff'
import ActivityNonGenReport from '@/components/reports/activity/nonGen'

import ActivityGen from '@/components/activity/gen/index'
import ActivityNonGen from '@/components/activity/nonGen/index'
import ActivityGenStaff from '@/components/activity/genStaff/index'

import Test from '@/components/test'

Vue.use(Router)

const router = new Router({
	mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/logout',
      redirect: to => {
        // console.log('vueAuthInstance', vueAuthInstance.logout())
        // sessionStorage.clear()
        // localStorage.clear()
        vueAuthInstance.logout()
        return '/login'
      }
    },
    {
      path: '/',
      component: DashView,
      meta: { auth: true},
      /*redirect: to => {
        return '/management/course/'
      },*/
      children: [
        {
          path: 'management/course/academicYears',
          component: CourseView,
          meta: { auth: true },
          /*redirect: to => {
            return '/academicYear'
          },*/
          children: [
            {
              path: '/',
              name: 'academicYear',
              component: AcademicYear,
              props: true,
              meta: { auth: true, description: 'ปี/ภาคการศึกษา' }
            },
            {
              path: ':academicYearId/activeCourses',
              name: 'activeCourse',
              component: ActiveCourse,
              props: true,
              meta: { auth: true, description: 'เปิดวิชา' }
            },
            {
              path: ':academicYearId/activeCourses/:activeCourseId/sections',
              name: 'section',
              component: Section,
              props: true,
              meta: { auth: true, description: 'กลุ่มใหญ่' }
            },
            {
              path: ':academicYearId/activeCourses/:activeCourseId/sections/:sectionId',
              name: 'sectionShow',
              component: SectionShow,
              props: true,
              meta: { auth: true, description: 'กลุ่มใหญ่' }
            }
          ]
        },
        {
          path: '/management/course/coursePlan',
          name: 'coursePlan',
          component: CoursePlan,
          props: true,
          meta: { auth: true, description: 'แผนการสอน' }
        },   
        {
          path: '/management/instructors',
          name: 'instructor',
          component: Instructor,
          props: true,
          meta: { auth: true, description: 'วิทยากร' }
        },
        {
          path: '/management/internets',
          name: 'internet',
          component: Internet,
          props: true,
          meta: { auth: true, description: 'บัญชีอินเตอร์เนต' }
        },
        {
          path: '/management/parkings',
          name: 'parking',
          component: Parking,
          props: true,
          meta: { auth: true, description: 'สติ๊กเกอร์จอดรถ' }
        },
        {
          path: '/management/persons',
          name: 'person',
          component: Person,
          props: true,
          meta: { auth: true, description: 'รายการบุคคล' }
        },
        {
          path: '/management/persons/:personId',
          name: 'personShow',
          component: PersonShow,
          props: true,
          meta: { auth: true, description: 'แสดงข้อมูลบุคคล' }
        },
        {
          path: '/management/students',
          name: 'student',
          component: Student,
          props: true,
          meta: { auth: true, description: 'คำร้องนักศึกษา' }
        },
        {
          path: '/activity/gen',
          name: 'activityGen',
          component: ActivityGen,
          props: true,
          meta: { auth: true, description: 'GEN' }
        },
        {
          path: '/activity/nonGen',
          name: 'activityNonGen',
          component: ActivityNonGen,
          props: true,
          meta: { auth: true, description: 'NON-GEN' }
        },
        {
          path: '/activity/genStaff',
          name: 'activityGenStaff',
          component: ActivityGenStaff,
          props: true,
          meta: { auth: true, description: 'GEN-STAFF' }
        },
        {
          path: 'reports',
          component: Reports,
          meta: { description: ' รายงาน', auth: true },
          children: [
            {
              path: 'activity/gen',
              component: ActivityGenReport,
              name: 'activityGenReport',
              meta: { description: ' โครงการสำนักงาน', auth: true }
            },
            {
              path: 'activity/genStaff',
              component: ActivityGenStaffReport,
              name: 'activityGenStaffReport',
              meta: { description: ' โครงการหน่วยงานภายนอก', auth: true }
            },
            {
              path: 'activity/nonGen',
              component: ActivityNonGenReport,
              name: 'activityNonGenReport',
              meta: { description: ' โครงการงานบริการวิชาการ', auth: true }
            },
            {
              path: 'guests',
              component: Guest,
              name: 'guest',
              meta: { description: ' ข้อมูลวิทยากร', auth: true }
            },
            {
              path: 'persons',
              component: PersonReport,
              name: 'persons',
              meta: { description: ' ข้อมูลการสอนรายบุคคล', auth: true }
            },
            {
              path: 'teachingSubjects',
              component: TeachingSubjects,
              name: 'teachingSubjects',
              meta: { description: ' ข้อมูลการสอน', auth: true }
            },
            {
              path: 'coursePlans',
              component: CoursePlanReport,
              name: 'coursePlans',
              meta: { description: ' ข้อมูลแผนการสอน', auth: true }
            },
            {
              path: 'wages',
              component: Wage,
              name: 'wage',
              meta: { description: ' ค่าตอบแทน', auth: true }
            },
            {
              path: 'workloads',
              component: Workload,
              name: 'workload',
              meta: { description: ' ภาระงาน', auth: true }
            },
            {
              path: 'aggregateStudents',
              component: AggregateStudent,
              name: 'aggregateStudent',
              meta: { description: ' สรุปจำนวนนักศึกษา', auth: true }
            },
            {
              path: 'parkings',
              component: ParkingRequest,
              name: 'parkingReport',
              meta: { description: ' สติ๊กเกอร์จอดรถ', auth: true }
            },
            {
              path: 'internets',
              component: InternetRequest,
              name: 'internetReport',
              meta: { description: ' บัญชีอินเตอร์เนต', auth: true }
            },
            {
              path: 'students',
              component: StudentRequest,
              name: 'studentReport',
              meta: { description: ' คำร้องนักศึกษา', auth: true }
            },
          ]
        },
        {
          path: '/settings/buildings',
          name: 'building',
          component: Building,
          props: true,
          meta: { auth: true, description: 'อาคาร/ห้องเรียน' }
        },
        {
          path: '/settings/personTypes',
          name: 'personType',
          component: PersonType,
          props: true,
          meta: { auth: true, description: 'รายการประเภทบุคคล' }
        },
        {
          path: '/settings/activityTypes',
          name: 'activityType',
          component: ActivityType,
          props: true,
          meta: { auth: true, description: 'รายการประเภทโครงการ' }
        },
        {
          path: '/settings/campus',
          name: 'campus',
          component: Campus,
          meta: { auth: true, description: 'วิทยาเขต/คณะ/ภาควิชา' }
        },
        {
          path: '/settings/subjects',
          name: 'subject',
          component: Subject,
          meta: { auth: true, description: 'รายวิชา' }
        },
        {
          path: '/settings/wageRates',
          name: 'wageRate',
          component: WageRate,
          meta: { auth: true, description: 'อัตราค่าตอบแทน' }
        },{
          path: '/upload',
          name: 'upload',
          component: Test,
          meta: { auth: true, description: 'upload' }
        },
        {
          path: '/404',
          name: 'NotFound',
          component: NotFound,
          props: true,
          meta: { auth: true, description: '404' }
        },
      ]
    }
  ]
})

router.beforeEach(function (to, from, next) {
  console.log('Token', vueAuthInstance.getToken())
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth) {
      if (vueAuthInstance.isAuthenticated()) {
        vueAuthInstance.$http.get(vueAuthInstance.options.validateUrl, { headers: { 'Authorization': 'Bearer ' + vueAuthInstance.getToken() } })
          .then((response) => {
            next()
          }, (error) => {
            console.log(error)
            router.push({ name: 'login' })
          })
      } else {
        router.push({ name: 'login' })
      }
    } else {
      if (vueAuthInstance.isAuthenticated()) {
        vueAuthInstance.$http.get(vueAuthInstance.options.validateUrl, { headers: { 'Authorization': 'Bearer ' + vueAuthInstance.getToken() } })
          .then(response => {
            router.push({ name: 'index' })
          }, (error) => {
            console.log(error)
            router.push({ name: 'login' })
          })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js